(ns minorodata.components.core
  (:require [cljs.spec.test.alpha]
            [minorodata.app.config]
            [minorodata.app.events]
            [minorodata.app.subs]
            [minorodata.components.admin.core :as c.admin]
            [minorodata.components.analytics-models.core :as c.analytics-models]
            [minorodata.components.connections.core :as c.connections]
            [minorodata.components.data-apps.core :as c.data-apps]
            [minorodata.components.data-apps.dashboards :as c.data-apps-dashboards]
            [minorodata.components.data-views.core :as c.data-views]
            [minorodata.components.dynamic-docs.core :as c.dynamic-docs]
            [minorodata.components.file-ingest.core :as c.file-ingest]
            [minorodata.components.home.core :as c.home]
            [minorodata.components.log.core :as c.log]
            [minorodata.components.login.core :as c.login]
            [minorodata.components.privacy-policy.core :as c.privacy-policy]
            [minorodata.components.warehouse-usage.core :as c.warehouse-usage]
            [minorodata.components.sql-console.core :as c.sql-console]
            [minorodata.components.tables.core :as c.tables]
            [minorodata.components.tables.details :as c.tables-details]
            [minorodata.components.transformations.core :as c.transformations]
            [minorodata.components.ui.core :as c.ui]
            [minorodata.components.warehouse-credentials.core :as c.warehouse-credentials]
            [minorodata.components.webforms.core :as c.webforms]
            [minorodata.components.transform-queue.core :as c.transform-queue]
            [minorodata.components.dag.core :as c.dag]
            [minorodata.components.pipeline-editor.core :as c.pipeline-editor]
            [minorodata.components.home-dashboard.core :as c.home-dashboard]
            [minorodata.components.audit-log.core :as c.audit-log]
            [minorodata.components.not-found.core :as c.not-found]
            [minorodata.components.feature-request.core :as c.feature-request]))



(defn screen-components [{:keys [route-name]}]
  (case route-name
    :privacy-policy
    {:main   c.privacy-policy/privacy-policy
     :params {:sidebar   false
              :container {:single-screen false}}}

    :home
    {:main   c.home/welcome
     :params {:container {:single-screen true}}}

    :login-callback
    {:main   c.login/login-callback
     :params {:container {:single-screen true}}}

    :log
    {:main        c.log/logs-page
     :permissions #{:logs/read}}

    :file-ingest
    {:main         c.file-ingest/file-ingest-page
     :permissions  #{:file-ingest/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :ingest]]}

    :admin
    {:main   c.admin/admin-page
     :permissions #{:admin/all}}

    (:transformations :transforms :transform-details
                      :new-group-form :new-transform-form :group-details ;; Old transform page routes
                      )
    {:main         c.transformations/main
     :permissions  #{:transforms/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :transforms]]}

    :connections
    {:main        c.connections/overview
     :permissions #{:connections+transforms/read}}

    (:extracts :source-details :extract-details)
    {:main         c.connections/extracts-list
     :permissions  #{:sources/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :ingest]]}

    (:analytics-models :analytics-model-create :analytics-model-instance-details :analytics-model-instance-edit)
    {:main         c.analytics-models/instances-list
     :permissions  #{:analytics-models/read}
     :feature-flag ["fe.analytics-models"]}

    :sources
    {:main         c.connections/sources-list
     :permissions  #{:new-source/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :ingest]]}

    :dag
    {:main         c.dag/main
     :params       {:container {:single-screen true}}
     :permissions  #{:dag/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :dag]]}


    :sql-console
    {:main         c.sql-console/main
     :params       {:container {:single-screen true}}
     :permissions  #{:sql-browser/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :sql-console]]}

    (:data-views :data-view-details)
    {:main         c.data-views/main
     :permissions  #{:data-views/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :data-views]]}

    (:dynamic-docs :dynamic-docs-details)
    {:main         c.dynamic-docs/main
     :permissions  #{:dynamic-docs/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :dynamic-docs]]}

    :warehouse-credentials
    {:main   c.warehouse-credentials/main}

    :feature-request
    {:main   c.feature-request/page}

    (:webforms :webforms-table)
    {:main         c.webforms/webforms-page
     :permissions  #{:webforms/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :webforms]]}

    :warehouse-usage
    {:main         c.warehouse-usage/page
     :params       {:container {:single-screen true}}
     :permissions  #{:warehouse-health/read}
     :feature-flag ["cost-section"
                    [:app.subs/enabled-for-bigquery :costs]]}

    :forbidden
    {:main   c.login/forbidden
     :params {:container {:single-screen true}}}

    :tables
    {:main         c.tables/page
     :params       {:container {:single-screen true}}
     :permissions  #{:tables/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :tables]]}

    :table-details
    {:main         c.tables-details/page
     :params       {:container {:single-screen true}}
     :permissions  #{:tables/read}
     :feature-flag [[:app.subs/enabled-for-bigquery :tables]]}

    :pipeline-editor
    {:main         c.pipeline-editor/page
     :permissions  #{:pipeline-editor/read}
     :params       {:container {:single-screen true}}}

    :dashboard
    {:main         c.home-dashboard/old-page}

    :overview
    {:main         c.home-dashboard/page}

    :audit-logs
    {:main         c.audit-log/page}

    :data-apps
    {:main         c.data-apps/page}

    (:data-apps-acquisition-audience-ai
     :data-apps-acquisition-market-view
     :data-apps-acquisition-spend-optimisation
     :data-apps-customers-customer-view
     :data-apps-customers-ai-segmentation
     :data-apps-customers-churn-prediction
     :data-apps-products-product-view
     :data-apps-products-demand
     :data-apps-products-inventory
     :data-apps-management-scorecard
     :data-apps-management-sales
     :data-apps-management-hubspot
     :data-apps-agriculture-futures
     :data-apps-agriculture-contracts-overview
     :data-apps-agriculture-market-analysis
     :data-apps-agriculture-trading-analysis
     :data-apps-workbook)
    {:main         c.data-apps-dashboards/dashboard-page}

    :transform-queue
    {:main         c.transform-queue/page}

    :ui
    {:main   c.ui/page}

    :not-found {:main c.not-found/not-found-page}

    {:main :div}))
